// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__yowDY","rootSmall":"AddTileButton_rootSmall__2H2ep"};